import { types, NAME } from "./reducer";
import { RSAA } from "redux-api-middleware";
import entryPoint from "../../constants/endpoints";
import sortingRule_Products from "../../constants/sorting_rules";

import { actions as mainActions } from "../Root/actions";
import { skipNextLeaveCheck } from "../../components/leaveGuard";
import { actions as productActions } from "../Product/actions";

export const actions = {
  getRevenue: (data) => (dispatch) => dispatch({}),
  editNotification: () => (dispatch, getState) => {
    return dispatch({
      type: types.EDIT_NOTIFICATION,
      showEditNotification: !getState()[NAME].showEditNotification,
    });
  },
  // Закрывает формы на странице компании (уведомления, заметка, культура) без сохранения.
  resetCompanyForms: () => (dispatch) => {
    dispatch(productActions.dropCurrentProduct());
    return dispatch({ type: types.COMPANY_FORMS_RESET });
  },
  createMemoAction: () => (dispatch, getState) => {
    return dispatch({
      type: types.CREATE_MEMO_ACTION,
      showCreateMemo: !getState()[NAME].showCreateMemo,
    });
  },
  createProductAction: () => (dispatch, getState) => {
    dispatch(productActions.dropCurrentProduct());
    return dispatch({
      type: types.CREATE_PRODUCT_ACTION,
      showCreateProduct: !getState()[NAME].showCreateProduct,
    });
  },
  editProductAction: () => (dispatch, getState) => {
    return dispatch({
      type: types.EDIT_PRODUCT_ACTION,
      showCreateProduct: !getState()[NAME].showCreateProduct,
    });
  },
  getCompany: (value) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.GET_COMPANY_REQUEST,
            payload: (action, state, res) => {
              console.log('Request payload:', value);
              return;
            },
          },
          {
            type: types.GET_COMPANY_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((data) => {
                console.log('Success payload:', data);
                return data;
              }),
          },
          {
            type: types.GET_COMPANY_FAILURE,
            payload: (action, state, res) => {
              console.error('Error payload:', res);
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/getcompany`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify({ id: value }), // Ensure this is an object
        headers: { "Content-Type": "application/json" },
      },
    }),
  
  
  getCompaniesList: (value) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.COMPANIES_LIST_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.COMPANIES_LIST_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((data) => {
                console.log('data.companyList')
                console.log(data.companyList)
                return data;
              }),
          },
          {
            type: types.COMPANIES_LIST_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/companylist`,
        credentials: "include",
        method: "GET",
      },
    }),
  editCompany: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.COMPANY_EDIT_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.COMPANY_EDIT_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((respData) => {
                // Форма сохранена: уход с неё уже не потеря изменений, предупреждать не о чем.
                skipNextLeaveCheck();
                dispatch(
                  // Форму открыли со страницы компании («Редактировать» ставит метку fromCompany):
                  // после «Сохранить» возвращаемся на неё по истории, а не дублируем запись.
                  mainActions.redirectTo("/companypage?id=" + data.id, { back: "fromCompany" })
                );
                let alert = {
                  show: true,
                  alertTitle: "Компания успешно изменена",
                  severity: "success",
                  style: {},
                  variant: "outlined",
                };
                dispatch(mainActions.showAlert(alert));
                return;
              }),
          },
          {
            type: types.COMPANY_EDIT_FAILURE,
            payload: (action, state, res) =>
              res.json().then((data) => {
                let alert = {
                  show: true,
                  alertTitle: "Ошибка при изменении компании",
                  alertText: "Не извесная ошибка",
                  severity: "error",
                  style: {},
                  variant: "outlined",
                };
                // Сервер отклонил данные и объяснил почему (например, неверный телефон).
                if (typeof data.message === "string") {
                  alert = { ...alert, alertText: data.message };
                }
                if (data.message.code === "ER_DUP_ENTRY") {
                  alert = {
                    ...alert,
                    alertText: "Компания с таким названием уже сущевствует!",
                  };
                }
                dispatch(mainActions.showAlert(alert));
                return;
              }),
          },
        ],
        endpoint: `${entryPoint}/editcompany`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  createCompany: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.COMPANY_CREATE_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.COMPANY_CREATE_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((data) => {
                dispatch(
                  mainActions.redirectTo(
                    "/companypage?id=" +
                      data.companyIncert.insertId // + "&justCreated=true"
                  )
                );
                let alert = {
                  show: true,
                  alertTitle: "Компания успешно создана",
                  severity: "success",
                  style: {},
                  variant: "outlined",
                };
                dispatch(mainActions.showAlert(alert));
                dispatch(
                  productActions.getProductList({
                    companyId: data.companyIncert.insertId,
                  })
                );
                return;
              }),
          },
          {
            type: types.COMPANY_CREATE_FAILURE,
            payload: (action, state, res) =>
              res.json().then((data) => {
                let alert = {
                  show: true,
                  alertTitle: "Ошибка при создании компании",
                  alertText: "Не извесная ошибка",
                  severity: "error",
                  style: {},
                  variant: "outlined",
                };
                // Сервер отклонил данные и объяснил почему (например, неверный телефон).
                if (typeof data.message === "string") {
                  alert = { ...alert, alertText: data.message };
                }
                if (data.message.code === "ER_DUP_ENTRY") {
                  alert = {
                    ...alert,
                    alertText: "Компания с таким названием уже сущевствует!",
                  };
                }
                dispatch(mainActions.showAlert(alert));
                return;
              }),
          },
        ],
        endpoint: `${entryPoint}/createcompany`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  setCurrentCompany: (value) => (dispatch, getState) => {
    let thisState = getState()[NAME];
    let selected = thisState.tableData.find((element, index, array) => {
      return element.id === value;
    });
    // Добавляет запись в историю: «назад» со страницы компании возвращает на список.
    dispatch(
      mainActions.redirectTo("/companypage?id=" + value, {
        push: true,
        state: { fromList: true },
      })
    );
    return dispatch({
      type: types.SELECTED_COMPANY_SET,
      payload: selected,
    });
  },
  //---------------------------------------------------------------------------------------
  createOrUpdateNotification: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.NOTIFICATION_CREATE_OR_UPDATE_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.NOTIFICATION_CREATE_OR_UPDATE_SUCCESS,
            payload: (action, state, res) =>
              res.json().then(({ data }) => {
                let companyId = state[NAME].selectedCompany.id;
                dispatch(actions.getNotification({ companyId: companyId }));
                return;
              }),
          },
          {
            type: types.NOTIFICATION_CREATE_OR_UPDATE_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/createnotification`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  getNotification: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.GET_NOTIFICATION_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.GET_NOTIFICATION_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((data) => {
                return data[0];
              }),
          },
          {
            type: types.GET_NOTIFICATION_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/getNotification`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  createNotificationMemo: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.NORIFICATION_MEMO_CREATE_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.NORIFICATION_MEMO_CREATE_SUCCESS,
            payload: (action, state, res) =>
              res.json().then(({ data }) => {
                dispatch(
                  actions.getNotificationMemo({
                    companyId: state[NAME].selectedCompany.id,
                  })
                );
                return;
              }),
          },
          {
            type: types.NORIFICATION_MEMO_CREATE_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/createnotificationmemo`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
  getNotificationMemo: (data) => (dispatch) =>
    dispatch({
      [RSAA]: {
        types: [
          {
            type: types.GET_NORIFICATION_MEMO_REQUEST,
            payload: (action, state, res) => {
              return;
            },
          },
          {
            type: types.GET_NORIFICATION_MEMO_SUCCESS,
            payload: (action, state, res) =>
              res.json().then((data) => {
                return data;
              }),
          },
          {
            type: types.GET_NORIFICATION_MEMO_FAILURE,
            payload: (action, state, res) => {
              return;
            },
          },
        ],
        endpoint: `${entryPoint}/getnotificationmemo`,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(data),
        headers: { "Content-Type": "application/json" },
      },
    }),
    margeProductsToCompany: () => (dispatch, getState) =>
      dispatch({
        [RSAA]: {
          types: [
            {
              type: types.MARGE_PRODUCTS_REQUEST,
              payload: () => {
                return;
              },
            },
            {
              type: types.MARGE_PRODUCTS_SUCCESS,
              payload: (action, state, res) =>
                res.json().then((data) => {
                  
    
                  let newTableColumns = [];
                  console.log("tc: ", newTableColumns);
    
                  data.productTypes.map((item) => {
                    newTableColumns.push({
                      label: item.name,
                      name: "prt" + item.id,
                      options: {
                        filter: false,
                        display: item.id == 1,
                      },
                    });
                  });
    
                  const sortProducts = (products, sortingRule) => {
                    const sortedProducts = {};
                    sortingRule.forEach((product) => {
                      const key = Object.keys(products).find((k) =>
                        k.toLowerCase().includes(product.toLowerCase())
                      );
                      if (key) {
                        sortedProducts[key] = products[key];
                      }
                    });
                    // Add any remaining products that weren't in the sorting rule
                    Object.keys(products).forEach((key) => {
                      if (!sortedProducts[key]) {
                        sortedProducts[key] = products[key];
                      }
                    });
                    return sortedProducts;
                  };
  
    
                  data.companyList.forEach((company) => {
                    if (company.leftovers) {
                      company.leftovers = sortProducts(company.leftovers, sortingRule_Products);
                    }
                    if (company.sowingareas) {
                      company.sowingareas = sortProducts(company.sowingareas, sortingRule_Products);
                    }
                  });
    
              
    
                  return {
                    aditionalTableColumns: newTableColumns,
                    tableData: data.companyList,
                    productTypes: data.productTypes
                  };
                }),
            },
            {
              type: types.MARGE_PRODUCTS_FAILURE,
              payload: () => {
                return;
              },
            },
          ],
          endpoint: `${entryPoint}/companyListWithRemainder`,
          credentials: "include",
          method: "GET",
        },
      }),
    

    resetProductValues: () => (dispatch) =>
      dispatch({
        [RSAA]: {
          types: [
            {
              type: types.RESET_PRODUCT_VALUES_REQUEST,
              payload: () => {
                return;
              },
            },
            {
              type: types.RESET_PRODUCT_VALUES_SUCCESS,
              payload: (action, state, res) =>
                res.json().then((data) => {
                  dispatch(actions.margeProductsToCompany());
                  let alert = {
                    show: true,
                    alertTitle: "Площадь, сбор и остатки обнулены",
                    alertText: `Очищено записей: ${data.affectedRows}`,
                    severity: "success",
                    style: {},
                    variant: "outlined",
                  };
                  dispatch(mainActions.showAlert(alert));
                  return;
                }),
            },
            {
              type: types.RESET_PRODUCT_VALUES_FAILURE,
              payload: () => {
                let alert = {
                  show: true,
                  alertTitle: "Не удалось обнулить площадь, сбор и остатки",
                  alertText: "Не извесная ошибка",
                  severity: "error",
                  style: {},
                  variant: "outlined",
                };
                dispatch(mainActions.showAlert(alert));
                return;
              },
            },
          ],
          endpoint: `${entryPoint}/resetproductvalues`,
          credentials: "include",
          method: "POST",
          headers: { "Content-Type": "application/json" },
        },
      }),

    deleteCompany: (companyId) => (dispatch) =>
      dispatch({
        [RSAA]: {
          types: [
            {
              type: types.DELETE_COMPANY_REQUEST,
              payload: (action, state, res) => {
                console.log('COMPANY_DELETE_REQUEST')
                return;
              },
            },
            {
              type: types.DELETE_COMPANY_SUCCESS,
              payload: (action, state, res) =>
                res.json().then((data) => {
                  console.log('COMPANY_DELETE_SUCCESS')
                  // Компанию открыли из списка: возвращаемся на него, а не на удалённую компанию.
                  dispatch(mainActions.redirectTo("/companylist", { back: "fromList" }));
                  let alert = {
                    show: true,
                    alertTitle: "Компания успешно удалена",
                    severity: "success",
                    style: {},
                    variant: "outlined",
                  };
                  dispatch(mainActions.showAlert(alert));
                  return data;
                }),
            },
            {
              type: types.DELETE_COMPANY_FAILURE,
              payload: (action, state, res) =>
                res.json().then((data) => {
                  console.log('COMPANY_DELETE_FAILURE')
                  let alert = {
                    show: true,
                    alertTitle: "Ошибка при удалении компании",
                    alertText: "Не извесная ошибка",
                    severity: "error",
                    style: {},
                    variant: "outlined",
                  };
                  dispatch(mainActions.showAlert(alert));
                  return;
                }),
            },
          ],
          endpoint: `${entryPoint}/deletecompany`, // Adjust endpoint as necessary
          credentials: "include",
          method: "POST",
          body: JSON.stringify({ id: companyId }), // Ensure correct data format
          headers: { "Content-Type": "application/json" },
        },
      }),
    
  //-----------------------------------------------------------------------------------------
};
